import { render, staticRenderFns } from "./PaginationPage.vue?vue&type=template&id=94a50a6e&scoped=true&"
import script from "./PaginationPage.vue?vue&type=script&lang=js&"
export * from "./PaginationPage.vue?vue&type=script&lang=js&"
import style0 from "./PaginationPage.vue?vue&type=style&index=0&id=94a50a6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a50a6e",
  null
  
)

export default component.exports